var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mixin.loaded)?_c('table-component',{attrs:{"content":_vm.cases,"headings":_vm.headings,"item_keys":_vm.item_keys,"display_spec":_vm.caseSpecs,"empty_message":'The customer has no cases.'}}):_c('loader-component')}
var staticRenderFns = []

export { render, staticRenderFns }